export default __webpack_public_path__ + "static/media/padding.3d3c2759.jpg";